import { styled, List, ListItemButton, Box, Typography } from '@mui/material';
import { TOP_NAV, SIDEBAR_WIDTH } from '~/layouts/Layout/Layout.style';
import { pxToRem } from '~/theme/typography';

export const sideBar = {
  List: styled(List)(() => ({
    background: '#008A5D',
    height: `calc(100vh - ${TOP_NAV})`,
    minWidth: SIDEBAR_WIDTH,
    padding: '0px',
    marginTop: TOP_NAV,
    position: 'fixed',
    zIndex: '2',
    overflowY: 'auto',
  })),
  ListButton: styled(ListItemButton)(({ theme }) => ({
    color: 'white',
    fontWeight: '500',
    fontSize: pxToRem(18),
    cursor: 'pointer',
    padding: '0px 16px',
    '& span': {
      width: '100%',
      height: '100%',
      lineHeight: '20px',
      padding: '10px',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: theme.palette.primary.lighter,
        color: '#212B36',
      },
    },
    '&.Mui-selected span': {
      backgroundColor: theme.palette.primary.lighter,
      color: '#212B36',
    },
  })),
  DownloadSection: styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    padding: '8px 16px 0',
    boxSizing: 'border-box',
  })),
  DownloadLink: styled('a')(() => ({
    display: 'block',
    width: '100%',
    maxWidth: '180px',
    lineHeight: 0,
  })),
  DownloadImage: styled('img')(() => ({
    display: 'block',
    width: '100%',
    maxWidth: '180px',
    height: '52px',
    borderRadius: '8px',
  })),
  LoadingMessage: styled('div')(() => ({
    color: 'white',
    fontSize: pxToRem(20),
    marginTop: pxToRem(20),
  })),
};

const updateDialogStyle = styled(Box)(() => {
  const sidebarDOM = document.getElementById('sidebar');
  const sidebarWidth = sidebarDOM?.clientWidth;
  return {
    padding: '12px 16px',
    ...(sidebarWidth && { width: `${sidebarWidth}px` }),
    // minWidth: SIDEBAR_WIDTH,
    backgroundColor: '#005D51',
    position: 'fixed',
    bottom: 0,
    color: 'white',
    fontSize: pxToRem(18),
  };
});

const updateSubTextStyle = styled(Typography)(() => ({
  variants: 'body1',
  fontWeight: '500',
  color: '#C8FAD1',
}));

export const updateDialog = {
  Dialog: updateDialogStyle,
  DialogPlaceholder: styled(updateDialogStyle)(() => ({
    visibility: 'hidden',
    position: 'relative',
    width: '100%',
  })),
  SubText: updateSubTextStyle,
  SubTextWithLoading: styled(updateSubTextStyle)(({ theme }) => ({
    variants: 'body1',
    fontWeight: '500',
    color: '#C8FAD1',
    '&:after': {
      overflow: 'hidden',
      display: 'inline-block',
      verticalAlign: 'bottom',
      animation: 'ellipsis 900ms infinite',
      content: '"…"',
      width: 0,
      marginLeft: theme.spacing(0.5),
    },
    '@keyframes ellipsis': {
      to: {
        width: '1.25em',
      },
    },
  })),
};
